import { ComedianAnalyticsTagRow } from "../../models/comedian_analytics_tags";
import { createSupabaseAdminClient } from "../../supabase/supabase";
import { logSupabaseException } from "@punchup/sentry";

const TABLE = "comedian_analytics_tags";

/**
 * Lists a comedian's analytics tag rows (all providers, enabled or not) via
 * the service-role client. Authorization is the CALLER's responsibility —
 * the v2 manager route verifies the user manages the target comedian before
 * invoking this.
 */
export async function listComedianAnalyticsTags(
  comedianId: string
): Promise<ComedianAnalyticsTagRow[]> {
  const supabase = createSupabaseAdminClient();
  const { data, error } = await supabase
    .from(TABLE)
    .select("*")
    .eq("comedian_id", comedianId)
    .order("created_at", { ascending: true })
    .order("id", { ascending: true });

  if (error) {
    logSupabaseException(error, "Failed to list comedian analytics tags");
    throw error;
  }
  return data ?? [];
}
